import { useApolloClient } from '@apollo/react-hooks'
import { AugmentedCache } from './cache'

export const useShortIdsMapper = () => {
  const client = useApolloClient()
  return (client.cache as AugmentedCache).shortIdsMapper
}
